import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-image/withIEPolyfill"
import browser from 'browser-detect'
import BackgroundImage from 'gatsby-background-image'
import { Link } from "@components/Link"
import { useURL } from "@hooks/useURL"

import css from "@css/components/blocks/IndexSct01.module.styl"


export default function IndexHero()
{
    const q = useStaticQuery(graphql`
        query {
            title: file(relativePath: { eq: "Hero__img__title.svg" }) {
                publicURL
            }
            comming: file(relativePath: { eq: "Sct01__img__comming-bg@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 855) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `)

    const urls = useURL()
    return pug`
        div(className=${css.container})
            div(className=${css.inner})
                h2(className=${css.title})
                    span(className=${css.l1}) Photoshop Express モード。
                    span(className=${css.l2})
                        strong さぁ、映えよう。
            div(className=${css.movie})
                Image(fluid=${q.comming.childImageSharp.fluid} alt="arrows 5G × Adobe Photohosp Express スペシャルムービー近日公開")
            div(className=${css.inner})
                p(className=${css.text})
                    |いいね！な光景を目の前にしながら、伝えたい気持ちを写真にのせる、
                    |arrows 5Gなら、撮影から編集までが流れるような体験になります。
                p(className=${css.text_middle})
                    |「Photoshop Expressモード」の自動補正処理はAdobe Photoshop Expressアプリと連動しております。
                    br
                    |Google PlayでPhotoshop Expressアプリを常に最新のバージョンに更新することをお勧めします。



    `
}
